export var TAdvertBookingStatusEnum;
(function (TAdvertBookingStatusEnum) {
    TAdvertBookingStatusEnum["WAITING"] = "WAITING";
    TAdvertBookingStatusEnum["ACCEPTED"] = "ACCEPTED";
    TAdvertBookingStatusEnum["CONFIRMED"] = "CONFIRMED";
    TAdvertBookingStatusEnum["EXPIRED"] = "EXPIRED";
    TAdvertBookingStatusEnum["CANCELED"] = "CANCELED";
    TAdvertBookingStatusEnum["WAITING_MANGOPAY"] = "WAITING_MANGOPAY";
})(TAdvertBookingStatusEnum || (TAdvertBookingStatusEnum = {}));
